// extracted by mini-css-extract-plugin
export default {"signature":"signature--osONU","dialog":"dialog--zxRDI"};